// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"163a4176","201":"83c200e1","343":"472c80c5","983":"0ec64064"}[chunkId] + ".chunk.js";
};